import { render, staticRenderFns } from "./ChukuBill.vue?vue&type=template&id=0f024f52&scoped=true&"
import script from "./ChukuBill.vue?vue&type=script&lang=js&"
export * from "./ChukuBill.vue?vue&type=script&lang=js&"
import style0 from "./ChukuBill.vue?vue&type=style&index=0&id=0f024f52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f024f52",
  null
  
)

export default component.exports